export const CAPTCHA_VERIFIED = 'mtVerified';
export const CAPTCHA_RENDERED = 'mtRendered';
export const SCRIPT_MTCAPTCHA = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
export const SCRIPT_MTCAPTCHA2 = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';
